import { useTranslate } from "ra-core";

// What a deal shows where its company would be. A deal keeps living when its company
// is deleted, and can be created without one. LCATOMICZO-61.
export const NoCompanyLabel = () => {
  const translate = useTranslate();
  return (
    <span className="text-muted-foreground">
      {translate("resources.deals.no_company")}
    </span>
  );
};

// Stands in for CompanyAvatar so rows keep their alignment.
export const NoCompanyAvatar = ({ size }: { size: number }) => (
  <div
    className="bg-gray-300 rounded-full shrink-0"
    style={{ width: size, height: size }}
  />
);
